import { Resident, ResidentItem, ResidentStatus } from '@lmc/ts-common'
import GroupedOptionsMultiSelect from './GroupedOptionsMultiSelect'

type GroupedResidentsMultiSelectProps = {
  residents: Resident[] | ResidentItem[]
  title: string
  values?: string[]
  handleInputChange?: (newValue: any) => void
  [key: string]: any
}

const GroupedResidentsMultiSelect = ({
  residents,
  title,
  values,
  handleInputChange,
  ...props
}: GroupedResidentsMultiSelectProps) => {
  const groupedResidents: { [status: string]: Resident[] } = {
    [ResidentStatus.active]: [],
    [ResidentStatus.inactive]: [],
    [ResidentStatus.hospitalised]: [],
    [ResidentStatus.deceased]: [],
    [ResidentStatus.discharged]: [],
  }

  residents?.forEach?.((resident) => {
    const { status } = resident as unknown as Resident
    if (!groupedResidents[status]) {
      groupedResidents[status] = []
    }
    groupedResidents[status].push(resident as unknown as Resident)
  })

  return (
    <GroupedOptionsMultiSelect
      groupedOptions={groupedResidents}
      title={title}
      values={values}
      handleInputChange={(newValue: any) => handleInputChange?.(newValue)}
      {...props}
    />
  )
}

export default GroupedResidentsMultiSelect
